var PmdSlider = (function (exports) {
  'use strict';

  function styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = "pmd-slider{--slider-slides-per-view:1;--slider-slider-gap:0px;--slider-slide-aspect-ratio:1;--slider-draggable:false;--slider-infinite:false;--slider-autoplay-enabled:false;--slider-autoplay-delay:3000;--slider-autoplay-direction:default;cursor:default;display:flex;flex-direction:row;overflow:auto;position:relative;scroll-behavior:smooth;scroll-snap-type:x mandatory;scrollbar-width:none;user-select:none;width:100%}pmd-slider[draggable-enabled=true]{cursor:grab;scroll-snap-type:none}pmd-slider.is-dragging{cursor:grabbing;scroll-behavior:auto!important;scroll-snap-type:none}pmd-slider::-webkit-scrollbar{display:none}pmd-slide{--slide-width:calc((100% - var(--slider-slider-gap)*(var(--slider-slides-per-view) - 1))/var(--slider-slides-per-view));box-sizing:border-box;display:block;flex-shrink:0;height:0;margin-right:var(--slider-slider-gap);padding-bottom:calc(1/(var(--slider-slide-aspect-ratio))*var(--slide-width));position:relative;scroll-snap-align:start;width:var(--slide-width)}pmd-slider pmd-slide:last-child{margin-right:0}pmd-slide pmd-slide-content{height:100%;left:0;position:absolute;top:0;width:100%}pmd-slider-nav{cursor:pointer}pmd-slider-nav:has(button:disabled),pmd-slider-nav[disabled]{cursor:not-allowed}pmd-slider-nav button{pointer-events:none}pmd-slider-nav button:disabled{cursor:not-allowed;opacity:.5}pmd-slider-thumbs{--slider-slides-per-view:4;--slider-slider-gap:10px;--slider-slide-aspect-ratio:1;display:flex;overflow:auto;position:relative;scroll-behavior:smooth;scrollbar-width:none;user-select:none;width:100%}pmd-slider-thumbs[draggable-enabled=true],pmd-slider-thumbs[draggable-enabled=true] pmd-slide{cursor:grab}pmd-slider-thumbs.is-dragging,pmd-slider-thumbs.is-dragging pmd-slide{cursor:grabbing;scroll-behavior:auto!important}pmd-slider-thumbs::-webkit-scrollbar{display:none}pmd-slider-thumbs pmd-slide{--slide-width:calc((100% - var(--slider-slider-gap)*(var(--slider-slides-per-view) - 1))/var(--slider-slides-per-view));cursor:pointer;flex-shrink:0;height:0;margin-right:var(--slider-slider-gap);padding-bottom:calc(1/(var(--slider-slide-aspect-ratio))*var(--slide-width));width:var(--slide-width)}pmd-slider-thumbs pmd-slide:last-child{margin-right:0}pmd-slider-thumbs[draggable-enabled=true] pmd-slide:active{cursor:grabbing}";
  styleInject(css_248z);

  class PmdSlide extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('pmd-slide-content')) return;

      const content = document.createElement('pmd-slide-content');
      while (this.firstChild) {
        content.appendChild(this.firstChild);
      }
      this.appendChild(content);
    }
  }

  class PmdSlideContent extends HTMLElement {
    connectedCallback() {
    }
  }

  class PmdSlider extends HTMLElement {
    constructor() {
      super();
      this.state = {
        currentIndex: 0
      };
    }

    connectedCallback() {
      this._checkInfinite();
      this._checkDraggable();
      this._checkAutoplay();

      // Maintain current slide position on resize
      this._onResize = () => {
        this._checkInfinite();
        this._checkDraggable();
        this._checkAutoplay();
        this.scrollToIndex();
      };
      window.addEventListener('resize', this._onResize);

      // Track scroll to update currentIndex and handle snapping
      this._onScroll = () => {
        this.updateCurrentIndex();
        this._handleInfiniteScroll();

        if (!this._isProgrammaticScroll && !this._isDragging) {
          this._resetAutoplay(2);
        }

        // Emulate scroll snap only if CSS snap is NOT active (i.e. when dragging is enabled)
        if (this.getAttribute('draggable-enabled') !== 'true') return;
      };
      this.addEventListener('scroll', this._onScroll);


      this._onScrollEnd = () => {
          // On mobile, we avoid auto-snapping during/immediately after touch interaction
          // to let the browser's native momentum and our handleEnd logic finish.
          if (!this._isDragging && !this._isProgrammaticScroll && !this._isTouchInteraction) {
              this.snapToClosest();
          }
          this._isProgrammaticScroll = false;

          if (this._isDragging) return;

          const currentIdx = this._getClosestSlideIndex(this.scrollLeft);
          const slides = Array.from(this.querySelectorAll('pmd-slide'));
          const originalCount = slides.length - (this._numClones * 2);

          if (currentIdx < this._numClones) {
              console.log('jumping to', currentIdx + originalCount);
              this._jumpToSlide(currentIdx + originalCount);
          } else if (currentIdx >= this._numClones + originalCount) {
              console.log('jumping to', currentIdx - originalCount);
              this._jumpToSlide(currentIdx - originalCount);
          }

          this.dispatchEvent(new CustomEvent('pmd:slider:scroll', {
              bubbles: true,
              composed: true,
              detail: {
                  sliderId: this.id,
                  currentIndex: this.state.currentIndex
              }
          }));
      };
      // Use a debounced scroll listener to detect scroll end for programmatic scrolls
      this._onScrollEndFallback = () => {
          if (!this._isProgrammaticScroll) return;

          clearTimeout(this._scrollFallbackTimeout);
          this._scrollFallbackTimeout = setTimeout(() => {
              this._onScrollEnd();
          }, 150);
      };

      if ('onscrollend' in this) {
          this.addEventListener('scrollend', this._onScrollEnd);
      } else {
          this.addEventListener('scroll', this._onScrollEndFallback);
      }

      // Touch events - We still listen for touch to handle next/prev flick if needed, 
      // but CSS snap handles the actual alignment.
      this._onTouchStart = (e) => {
        this._isTouchInteraction = true;
        clearTimeout(this._touchInteractionTimeout);
        // For touch, we only need handleStart to clear timers and set start variables
        // but we don't want to prevent default or set scroll-behavior to auto
        this.handleStart(e.touches[0].pageX);
      };
      this._onTouchMove = (e) => {
          // We let the browser handle the scroll
      };
      this._onTouchEnd = (e) => {
        // Keep _isTouchInteraction true for a bit to let momentum/scroll events finish
        clearTimeout(this._touchInteractionTimeout);
        this._touchInteractionTimeout = setTimeout(() => {
          this._isTouchInteraction = false;
        }, 500);
        this.handleEnd();
      };

      this.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.addEventListener('touchmove', this._onTouchMove, { passive: true });
      this.addEventListener('touchend', this._onTouchEnd);

      // Mouse events
      this._onMouseDown = (e) => {
        if (this.getAttribute('draggable-enabled') !== 'true') return;
        this._isTouchInteraction = false; // Mouse interaction
        clearTimeout(this._touchInteractionTimeout);
        this.handleStart(e.pageX);
        this.classList.add('is-dragging');
      };
      this._onMouseMove = (e) => {
        if (!this._isDragging) return;
        e.preventDefault();
        this.handleMove(e.pageX);
      };
      this._onMouseUp = () => {
        if (!this._isDragging) return;
        this.handleEnd();
        this.classList.remove('is-dragging');
      };

      this.addEventListener('mousedown', this._onMouseDown);
      window.addEventListener('mousemove', this._onMouseMove);
      window.addEventListener('mouseup', this._onMouseUp);

      this._resizeObserver = new ResizeObserver(() => this._onResize());
      this._resizeObserver.observe(this);
    }

    _checkDraggable() {
      // Check if the primary pointer is coarse (like a finger)
      const isTouchPrimary = window.matchMedia("(pointer: coarse)").matches;
      const isDraggableValue = getComputedStyle(this).getPropertyValue('--slider-draggable').trim() === 'true';
      
      // If device primary input is touch, we disable JS dragging and use CSS snap
      const isDraggable = !isTouchPrimary && isDraggableValue;
      this.setAttribute('draggable-enabled', isDraggable);
    }

    _checkInfinite() {
      const isInfinite = getComputedStyle(this).getPropertyValue('--slider-infinite').trim() === 'true';
      if (isInfinite && !this._isInfinite) {
        this._isInfinite = true;
        this._setupInfinite();
      } else if (!isInfinite && this._isInfinite) {
        this._isInfinite = false;
        this._cleanupInfinite();
      }
    }

    _setupInfinite() {
      const originalSlides = Array.from(this.querySelectorAll('pmd-slide:not([cloned])'));
      if (originalSlides.length === 0) return;

      // Clone slides
      const slidesPerView = Math.ceil(parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1);
      
      // We need enough clones to fill the view on both sides. 
      // Usually cloning all slides is safer if the number of slides is small.
      const numClones = Math.max(slidesPerView, originalSlides.length);

      // Clone at the end (to be placed at the beginning)
      for (let i = 0; i < numClones; i++) {
        const slideToClone = originalSlides[(originalSlides.length - numClones + i) % originalSlides.length];
        const clone = slideToClone.cloneNode(true);
        clone.setAttribute('cloned', 'true');
        clone.setAttribute('original-index', (originalSlides.length - numClones + i) % originalSlides.length);
        this.insertBefore(clone, originalSlides[0]);
      }

      // Clone at the beginning (to be placed at the end)
      for (let i = 0; i < numClones; i++) {
        const slideToClone = originalSlides[i % originalSlides.length];
        const clone = slideToClone.cloneNode(true);
        clone.setAttribute('cloned', 'true');
        clone.setAttribute('original-index', i % originalSlides.length);
        this.appendChild(clone);
      }

      this._numClones = numClones;
      
      // Initial scroll to the first real slide
      requestAnimationFrame(() => {
        this._isProgrammaticScroll = true;
        const firstRealSlide = originalSlides[0];
        this.scrollLeft = firstRealSlide.offsetLeft;
        setTimeout(() => {
          this._isProgrammaticScroll = false;
        }, 100);
      });
    }

    _cleanupInfinite() {
      const clonedSlides = this.querySelectorAll('pmd-slide[cloned]');
      clonedSlides.forEach(slide => slide.remove());
      this._numClones = 0;
    }

    _checkAutoplay() {
      const style = getComputedStyle(this);
      const isAutoplayEnabled = style.getPropertyValue('--slider-autoplay-enabled').trim() === 'true';
      const autoplayDelay = parseInt(style.getPropertyValue('--slider-autoplay-delay')) || 3000;
      const autoplayDirection = style.getPropertyValue('--slider-autoplay-direction').trim() || 'default';

      this._autoplayDelay = autoplayDelay;
      this._autoplayDirection = autoplayDirection;

      if (isAutoplayEnabled && !this._autoplayTimer) {
        this._startAutoplay();
      } else if (!isAutoplayEnabled && this._autoplayTimer) {
        this._stopAutoplay();
      }
    }

    _startAutoplay(delayMultiplier = 1) {
      this._stopAutoplay();
      if (getComputedStyle(this).getPropertyValue('--slider-autoplay-enabled').trim() !== 'true') return;

      this._autoplayTimer = setTimeout(() => {
        this._tickAutoplay();
      }, this._autoplayDelay * delayMultiplier);
    }

    _stopAutoplay() {
      if (this._autoplayTimer) {
        clearTimeout(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    }

    _resetAutoplay(delayMultiplier = 1) {
      this._stopAutoplay();
      this._startAutoplay(delayMultiplier);
    }

    _tickAutoplay() {
      if (this._autoplayDirection === 'reverse') {
        const slides = this.querySelectorAll('pmd-slide');
        if (!this._isInfinite && this.state.currentIndex === 0) {
          // Optional: loop back to end if not infinite? 
          // User didn't specify, but usually reverse autoplay at start should go to end or stop.
          // Let's just use prev() which handles infinite logic.
          this.scrollToIndex(slides.length - 1);
        } else {
          this.prev();
        }
      } else {
        const slides = this.querySelectorAll('pmd-slide');
        const slidesPerView = parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1;
        const maxIndex = Math.max(0, slides.length - slidesPerView);
        
        if (!this._isInfinite && this.state.currentIndex >= Math.ceil(maxIndex)) {
          this.scrollToIndex(0);
        } else {
          this.next();
        }
      }
      this._startAutoplay();
    }

    _handleInfiniteScroll() {
      if (!this._isInfinite) return;

      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      const numClones = this._numClones;
      const originalCount = slides.length - (numClones * 2);
      
      if (originalCount <= 0) return;

      const scrollLeft = this.scrollLeft;
      const firstRealSlide = slides[numClones];
      const lastRealSlide = slides[numClones + originalCount - 1];
      
      if (!firstRealSlide || !lastRealSlide) return;

      const viewportWidth = this.offsetWidth;
      const maxScrollLeft = this.scrollWidth - this.clientWidth;
      
      // Immediate swap if we hit physical boundaries
      if (scrollLeft <= 0) {
          const currentIdx = this._getClosestSlideIndex(scrollLeft);
          this._jumpToSlide(currentIdx + originalCount);
          return;
      }
      if (scrollLeft >= maxScrollLeft - 1) {
          const currentIdx = this._getClosestSlideIndex(scrollLeft);
          this._jumpToSlide(currentIdx - originalCount);
          return;
      }

      // Swapping during programmatic scroll or dragging
      // We only swap programmatically if we've scrolled PAST the clones (into empty space or just far enough)
      // or if we are dragging.
      if (this._isDragging) {
          if (scrollLeft < firstRealSlide.offsetLeft - (viewportWidth / 2)) {
              const currentIdx = this._getClosestSlideIndex(scrollLeft);
              this._jumpToSlide(currentIdx + originalCount);
              return;
          } 
          else if (scrollLeft > lastRealSlide.offsetLeft + (lastRealSlide.offsetWidth / 2)) {
              const currentIdx = this._getClosestSlideIndex(scrollLeft);
              this._jumpToSlide(currentIdx - originalCount);
              return;
          }
      }
    }

    _jumpToSlide(index) {
      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      const targetSlide = slides[index];
      if (!targetSlide) return;

      const oldScrollLeft = this.scrollLeft;

      // Calculate relative offset within the current slide to preserve it during jump
      const currentIdx = this._getClosestSlideIndex(oldScrollLeft);
      const currentSlide = slides[currentIdx];
      let relativeOffset = 0;
      if (currentSlide) {
          relativeOffset = oldScrollLeft - currentSlide.offsetLeft;
      }

      // Save current programmatic scroll state to restore it
      const wasProgrammatic = this._isProgrammaticScroll;
      this._isProgrammaticScroll = true;
      
      const isSnapEnabled = getComputedStyle(this).scrollSnapType !== 'none';
      if (isSnapEnabled) {
        this.style.scrollSnapType = 'none';
      }

      const originalScrollBehavior = this.style.scrollBehavior;
      this.style.scrollBehavior = 'auto';
      
      this.scrollLeft = targetSlide.offsetLeft + relativeOffset;
      const newScrollLeft = this.scrollLeft;

      // If we are dragging, we need to update _startScrollLeft to account for the jump
      if (this._isDragging) {
          this._startScrollLeft += (newScrollLeft - oldScrollLeft);
      }
      
      // Trigger update immediately so it's ready for any subsequent logic
      this.updateCurrentIndex();

      requestAnimationFrame(() => {
          if (isSnapEnabled) {
            this.style.scrollSnapType = '';
          }
          this.style.scrollBehavior = originalScrollBehavior;
          // Small delay to ensure browser processed the jump before allowing normal scroll events to take over
          setTimeout(() => {
              this._isProgrammaticScroll = wasProgrammatic;
          }, 50);
      });
    }

    _getClosestSlideIndex(scrollLeft) {
      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      if (slides.length === 0) return -1;

      const slidesPerView = parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1;
      const maxIndex = Math.max(0, slides.length - slidesPerView);
      const searchLimit = Math.ceil(maxIndex);

      let closestIndex = 0;
      let minDistance = Infinity;

      for (let i = 0; i < slides.length; i++) {
        if (i > searchLimit) break;
        
        const distance = Math.abs(slides[i].offsetLeft - scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = i;
        }
      }

      return closestIndex;
    }

    updateCurrentIndex() {
      const closestIndex = this._getClosestSlideIndex(this.scrollLeft);
      if (closestIndex === -1) return;

      let displayIndex = closestIndex;
      if (this._isInfinite) {
        const slides = Array.from(this.querySelectorAll('pmd-slide'));
        const numClones = this._numClones;
        const originalCount = slides.length - (numClones * 2);
        
        if (closestIndex < numClones) {
          displayIndex = (closestIndex - numClones + originalCount) % originalCount;
        } else if (closestIndex >= numClones + originalCount) {
          displayIndex = (closestIndex - numClones) % originalCount;
        } else {
          displayIndex = closestIndex - numClones;
        }
      }

      if (this.state.currentIndex !== displayIndex) {
        this.state.currentIndex = displayIndex;
      }
    }

    disconnectedCallback() {
      this._stopAutoplay();
      window.removeEventListener('resize', this._onResize);
      this.removeEventListener('scroll', this._onScroll);
      this.removeEventListener('scroll', this._onScrollEndFallback);
      this.removeEventListener('touchstart', this._onTouchStart);
      this.removeEventListener('touchmove', this._onTouchMove);
      this.removeEventListener('touchend', this._onTouchEnd);
      this.removeEventListener('mousedown', this._onMouseDown);
      window.removeEventListener('mousemove', this._onMouseMove);
      window.removeEventListener('mouseup', this._onMouseUp);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }

    handleStart(pageX) {
      this._isDragging = true;
      this._startX = pageX;
      this._startScrollLeft = this.scrollLeft;
      this._startTime = Date.now();
      
      // Stop any ongoing smooth scroll or snapping
      if (!this._isTouchInteraction) {
          this.style.scrollBehavior = 'auto';
      }
      this._isProgrammaticScroll = false;
      clearTimeout(this._snapTimeout);
      clearTimeout(this._interactionEndTimeout);
      this._stopAutoplay();
    }

    handleMove(pageX) {
      if (!this._isDragging || this._isTouchInteraction) return;
      const walk = (pageX - this._startX);
      this.scrollLeft = this._startScrollLeft - walk;
    }

    handleEnd() {
      if (!this._isDragging) return;
      const isTouch = this._isTouchInteraction;
      this._isDragging = false;
      this.style.scrollBehavior = ''; // Restore original behavior

      const endTime = Date.now();
      const duration = endTime - this._startTime;
      const distance = this.scrollLeft - this._startScrollLeft;

      this._resetAutoplay(2);

      // Small delay to ensure any native momentum start doesn't immediately fight with our snapping
      clearTimeout(this._interactionEndTimeout);
      this._interactionEndTimeout = setTimeout(() => {
          const isDraggable = this.getAttribute('draggable-enabled') === 'true';
          
          // If it's a mouse interaction and draggable is enabled, we use our JS logic.
          // If it's a touch interaction, we let CSS snap handle it.
          
          if (isDraggable && !isTouch) {
              // Fast swipe (flick) detection for mouse
              if (duration < 300 && Math.abs(distance) > 50) {
                  if (distance > 0) {
                      this.next();
                  } else {
                      this.prev();
                  }
              } else {
                  // Slow drag or short movement for mouse
                  this.snapToClosest();
              }
          }
          // For touch, we do nothing and let CSS Scroll Snap take over.
      }, 10);
    }

    snapToClosest() {
      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      if (slides.length === 0) return;
      
      const slidesPerView = parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1;
      const maxIndex = Math.max(0, slides.length - slidesPerView);
      const maxScrollLeft = this.scrollWidth - this.clientWidth;

      let targetIndex;

      // If we are scrolled near the end, snap to the maxIndex
      if (this.scrollLeft > maxScrollLeft - 10 && !this._isInfinite) {
          targetIndex = Math.round(maxIndex);
      } else {
          targetIndex = this._getClosestSlideIndex(this.scrollLeft);
          // Clamp to maxIndex for non-end snapping
          if (targetIndex > maxIndex && !this._isInfinite) {
              targetIndex = Math.floor(maxIndex);
          }
      }

      if (targetIndex !== -1) {
        this._scrollToIndexRaw(targetIndex);
      }
    }

    next() {
      this._resetAutoplay(2);
      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      const slidesPerView = parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1;
      const maxIndex = Math.max(0, slides.length - slidesPerView);
      
      // Find next index based on current scroll position
      const currentScroll = this.scrollLeft;
      let nextIndex = 0;
      
      // If we are at the very end of physical scroll and infinite is enabled, 
      // we should have already jumped, but if not, let's force a jump or handle it.
      if (this._isInfinite) {
          const maxScrollLeft = this.scrollWidth - this.clientWidth;
          if (currentScroll >= maxScrollLeft - 1) {
              console.log(maxScrollLeft, currentScroll);
              // Jump to the equivalent real slide first, then go next
              const currentIdx = this._getClosestSlideIndex(currentScroll);
              const numClones = this._numClones;
              const originalCount = slides.length - (numClones * 2);
              this._jumpToSlide(currentIdx - originalCount);
              // After jump, we need to recalculate nextIndex
              requestAnimationFrame(() => this.next());
              return true;
          }
      }

      for (let i = 0; i < slides.length; i++) {
          if (slides[i].offsetLeft > currentScroll + 1) {
              nextIndex = i;
              break;
          }
      }
      
      if (!this._isInfinite) {
          nextIndex = Math.min(nextIndex, Math.ceil(maxIndex));
      }
      this._scrollToIndexRaw(nextIndex);
      return true;
    }

    prev() {
      this._resetAutoplay(2);
      const currentScroll = this.scrollLeft;
      const slides = Array.from(this.querySelectorAll('pmd-slide'));

      if (this._isInfinite && currentScroll <= 0) {
          // Jump to the equivalent real slide first, then go prev
          const currentIdx = this._getClosestSlideIndex(currentScroll);
          const numClones = this._numClones;
          const originalCount = slides.length - (numClones * 2);
          this._jumpToSlide(currentIdx + originalCount);
          requestAnimationFrame(() => this.prev());
          return true;
      }

      let prevIndex = 0;
      for (let i = slides.length - 1; i >= 0; i--) {
          if (slides[i].offsetLeft < currentScroll - 1) {
              prevIndex = i;
              break;
          }
      }
      
      if (!this._isInfinite) {
          prevIndex = Math.max(0, prevIndex);
      }
      this._scrollToIndexRaw(prevIndex);
      return true;
    }

    canNext() {
      if (this._isInfinite) return true;
      const slides = this.querySelectorAll('pmd-slide');
      const slidesPerView = parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1;
      const limit = Math.max(0, slides.length - slidesPerView);
      return this.state.currentIndex < limit;
    }

    canPrev() {
      if (this._isInfinite) return true;
      return this.state.currentIndex > 0;
    }

    scrollToIndex(index) {
      this._resetAutoplay(2);
      const isProgrammatic = typeof index === 'number';
      let targetIndex = isProgrammatic ? index : this.state.currentIndex;
      
      if (this._isInfinite) {
          // Map original index to the one in the middle section
          targetIndex = targetIndex + this._numClones;
      }

      this._scrollToIndexRaw(targetIndex);
    }

    _scrollToIndexRaw(index) {
      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      let targetIndex = index;
      
      // Safety clamp if not infinite
      const slidesPerView = parseFloat(getComputedStyle(this).getPropertyValue('--slider-slides-per-view')) || 1;
      const maxIndex = Math.max(0, slides.length - slidesPerView);
      
      if (!this._isInfinite) {
          targetIndex = Math.max(0, Math.min(targetIndex, Math.ceil(maxIndex)));
      } else {
          // For infinite, we just clamp to actual slide range to avoid errors
          targetIndex = Math.max(0, Math.min(targetIndex, slides.length - 1));
      }

      const targetSlide = slides[targetIndex];
      if (!targetSlide) return;

      this._isProgrammaticScroll = true;

      const maxScrollLeft = this.scrollWidth - this.clientWidth;
      const targetLeft = Math.min(targetSlide.offsetLeft, maxScrollLeft);

      // If we are already at the target, we should still clear the flag after a bit
      if (Math.abs(this.scrollLeft - targetLeft) < 1) {
          this.updateCurrentIndex();
          setTimeout(() => {
              this._isProgrammaticScroll = false;
          }, 50);
          return;
      }

      this.scrollTo({
        top: 0,
        left: targetLeft,
        behavior: 'smooth'
      });
    }
  }
  window.addEventListener('pmd:slider:scroll', (e) => {
    console.log(e);
  });

  class PmdSliderNav extends HTMLElement {
    connectedCallback() {
      this._handleClick = () => {
        const direction = this.getAttribute('data-direction');
        const sliderId = this.getAttribute('data-slider');
        const slider = document.getElementById(sliderId);
        
        if (!slider) return;

        // Check if we can navigate before executing
        if (direction === 'next' && !slider.canNext()) return;
        if (direction === 'prev' && !slider.canPrev()) return;

        if (direction === 'next' && slider.next) {
          slider.next();
        } else if (direction === 'prev' && slider.prev) {
          slider.prev();
        }
        
        // Update our own state immediately
        this.updateDisabledState();
      };
      this.addEventListener('click', this._handleClick);

      // Update state when slider scrolls
      this._handleSliderScroll = (e) => {
        if (e.detail.sliderId === this.getAttribute('data-slider')) {
          this.updateDisabledState();
        }
      };
      window.addEventListener('pmd:slider:scroll', this._handleSliderScroll);
      
      // Initial state
      setTimeout(() => this.updateDisabledState(), 0);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._handleClick);
      window.removeEventListener('pmd:slider:scroll', this._handleSliderScroll);
    }

    updateDisabledState() {
      const direction = this.getAttribute('data-direction');
      const sliderId = this.getAttribute('data-slider');
      const slider = document.getElementById(sliderId);
      const button = this.querySelector('button');
      
      if (!slider || !button) return;

      let isDisabled = false;
      if (direction === 'next') {
        isDisabled = !slider.canNext();
      } else if (direction === 'prev') {
        isDisabled = !slider.canPrev();
      }

      if (isDisabled) {
        button.setAttribute('disabled', '');
      } else {
        button.removeAttribute('disabled');
      }
    }
  }

  class PmdSliderThumbs extends HTMLElement {
    constructor() {
      super();
      this.state = {
        currentIndex: 0
      };
    }

    connectedCallback() {
      this._checkDraggable();

      // Maintain current slide position on resize
      this._onResize = () => {
        this._checkDraggable();
        this.scrollToIndex(); 
      };
      window.addEventListener('resize', this._onResize);

      this._resizeObserver = new ResizeObserver(() => this._onResize());
      this._resizeObserver.observe(this);

      this.setupThumbClicks();

      // Mouse events for freedrag
      this._onMouseDown = (e) => {
        if (this.getAttribute('draggable-enabled') !== 'true') return;
        this.handleStart(e.pageX);
        this.classList.add('is-dragging');
      };
      this._onMouseMove = (e) => {
        if (!this._isDragging) return;
        e.preventDefault();
        this.handleMove(e.pageX);
      };
      this._onMouseUp = () => {
        if (!this._isDragging) return;
        this.handleEnd();
        this.classList.remove('is-dragging');
      };

      this.addEventListener('mousedown', this._onMouseDown);
      window.addEventListener('mousemove', this._onMouseMove);
      window.addEventListener('mouseup', this._onMouseUp);
      
      // Listen for main slider changes to sync thumbs
      this._handleMainSliderScroll = (e) => {
        if (e.detail.sliderId === this.getAttribute('data-slider')) {
          this.scrollToIndex(e.detail.currentIndex);
        }
      };
      this.updateActiveThumb();
      window.addEventListener('pmd:slider:scroll', this._handleMainSliderScroll);
    }

    _checkDraggable() {
      // Check if the primary pointer is coarse (like a finger)
      const isTouchPrimary = window.matchMedia("(pointer: coarse)").matches;
      // For thumbs, we enable dragging on desktop (non-touch) by default or we can use a property
      // The issue description says "add freedrag for thumbs on desktop (devices that dont support touch)"
      const isDraggable = !isTouchPrimary;
      this.setAttribute('draggable-enabled', isDraggable);
    }

    handleStart(pageX) {
      this._isDragging = true;
      this._startX = pageX;
      this._startScrollLeft = this.scrollLeft;
      
      this.style.scrollBehavior = 'auto';
      this._isProgrammaticScroll = false;
    }

    handleMove(pageX) {
      if (!this._isDragging) return;
      const walk = (pageX - this._startX);
      this.scrollLeft = this._startScrollLeft - walk;
    }

    handleEnd() {
      if (!this._isDragging) return;
      this._isDragging = false;
      this.style.scrollBehavior = ''; // Restore original behavior
      
      // Check if it was a drag to prevent the next click if it happens on a slide
      const distance = Math.abs(this.scrollLeft - this._startScrollLeft);
      if (distance > 5) {
        this._wasDragging = true;
        setTimeout(() => this._wasDragging = false, 100);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('pmd:slider:scroll', this._handleMainSliderScroll);
      window.removeEventListener('resize', this._onResize);
      this.removeEventListener('mousedown', this._onMouseDown);
      window.removeEventListener('mousemove', this._onMouseMove);
      window.removeEventListener('mouseup', this._onMouseUp);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }

    setupThumbClicks() {
      this.addEventListener('click', (e) => {
        if (this._wasDragging) {
          e.preventDefault();
          return;
        }
        const slide = e.target.closest('pmd-slide');
        if (slide) {
          const slides = Array.from(this.querySelectorAll('pmd-slide'));
          const index = slides.indexOf(slide);
          const sliderId = this.getAttribute('data-slider');
          
          if (sliderId) {
            const mainSlider = document.getElementById(sliderId);
            if (mainSlider && mainSlider.scrollToIndex) {
              this.scrollToIndex(index);
              mainSlider.scrollToIndex(index);
            }
          }
        }
      });
    }

    updateActiveThumb() {
      const slides = this.querySelectorAll('pmd-slide');
      slides.forEach((slide, index) => {
        slide.classList.remove('is-active');
        if (index === this.state.currentIndex) {
          slide.classList.add('is-active');
        }
      });
    }

    scrollToIndex(index) {
      const slides = Array.from(this.querySelectorAll('pmd-slide'));
      const isProgrammatic = typeof index === 'number';
      const targetIndex = isProgrammatic ? index : this.state.currentIndex;
      const targetSlide = slides[targetIndex];
      
      if (!targetSlide) return;

      const containerRect = this.getBoundingClientRect();
      const slideRect = targetSlide.getBoundingClientRect();
      
      // Check if target slide is fully visible
      const isVisible = (
        slideRect.left >= containerRect.left - 1 && 
        slideRect.right <= containerRect.right + 1
      );

      if (!isVisible) {
        // Find all fully visible slides
        const visibleSlides = slides.filter(slide => {
          const rect = slide.getBoundingClientRect();
          return rect.left >= containerRect.left - 1 && rect.right <= containerRect.right + 1;
        });

        let targetLeft;

        if (visibleSlides.length > 0) {
          // Find the range of slides to center
          const firstVisibleIdx = slides.indexOf(visibleSlides[0]);
          const lastVisibleIdx = slides.indexOf(visibleSlides[visibleSlides.length - 1]);
          const targetIdx = slides.indexOf(targetSlide);
          
          let newFirstIdx, newLastIdx;

          if (targetIdx > lastVisibleIdx) {
            // Moving forward: target becomes the last visible
            newLastIdx = targetIdx;
            newFirstIdx = Math.max(0, targetIdx - (visibleSlides.length - 1));
          } else if (targetIdx < firstVisibleIdx) {
            // Moving backward: target becomes the first visible
            newFirstIdx = targetIdx;
            newLastIdx = Math.min(slides.length - 1, targetIdx + (visibleSlides.length - 1));
          } else {
            // Already visible, shouldn't happen due to !isVisible check but for safety:
            newFirstIdx = firstVisibleIdx;
            newLastIdx = lastVisibleIdx;
          }

          const firstSlide = slides[newFirstIdx];
          const lastSlide = slides[newLastIdx];
          
          const rangeWidth = (lastSlide.offsetLeft + lastSlide.offsetWidth) - firstSlide.offsetLeft;
          const rangeCenter = firstSlide.offsetLeft + (rangeWidth / 2);
          
          targetLeft = rangeCenter - (containerRect.width / 2);
        } else {
          // Fallback to centering the target slide if nothing is fully visible
          targetLeft = targetSlide.offsetLeft - (containerRect.width / 2) + (targetSlide.offsetWidth / 2);
        }

        const maxScrollLeft = this.scrollWidth - this.clientWidth;
        targetLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

        this.scrollTo({
          top: 0,
          left: targetLeft,
          behavior: 'smooth'
        });
      }

      this.state.currentIndex = targetIndex;
      this.updateActiveThumb();
    }
  }

  customElements.define('pmd-slide', PmdSlide);
  customElements.define('pmd-slide-content', PmdSlideContent);
  customElements.define('pmd-slider', PmdSlider);
  customElements.define('pmd-slider-nav', PmdSliderNav);
  customElements.define('pmd-slider-thumbs', PmdSliderThumbs);

  exports.PmdSlide = PmdSlide;
  exports.PmdSlideContent = PmdSlideContent;
  exports.PmdSlider = PmdSlider;
  exports.PmdSliderNav = PmdSliderNav;
  exports.PmdSliderThumbs = PmdSliderThumbs;

  return exports;

})({});
//# sourceMappingURL=pmd-slider.bundle.js.map
